import constructMessageFromDetails from '../utils/constructMessageFromDetails';
import createDraft from '../services/createDraft';
import createFileAttachment from '../services/createFileAttachment';
import createItemAttachment from '../services/createItemAttachment';
import CreateItemResponse from 'owa-service/lib/contract/CreateItemResponse';
import MessageDetails from '../schema/MessageDetails';
import sendMessage from '../services/sendMessage';
import updateAndSendMessage from '../services/updateAndSendMessage';
import updateMessageId from '../utils/updateMessageId';
import { assertNever } from 'owa-assert';

export default async function sendAutomatedMessage(
    messageDetails: MessageDetails,
    timeFormat: string
): Promise<CreateItemResponse> {
    let attachments = messageDetails.attachments;
    let message = constructMessageFromDetails(messageDetails);

    if (!attachments) {
        return sendMessage(message, timeFormat);
    } else {
        let createDraftResponse = await createDraft(message, timeFormat);
        updateMessageId(message, createDraftResponse);

        if (!message.ItemId) {
            throw new Error('No ItemID on message');
        }

        for (const attachment of attachments) {
            switch (attachment.kind) {
                case 'Item':
                    // Attach any item specified attachments
                    await createItemAttachment(attachment.item, attachment.name, message.ItemId);
                    break;
                case 'File':
                    // Attach any blob file attachments
                    await createFileAttachment(attachment.content, attachment.name, message.ItemId);
                    break;
                default:
                    return assertNever(attachment);
            }
        }
        return updateAndSendMessage(message);
    }
}
